module.exports = __webpack_public_path__ + "img/c00_buildingtechreinforcedwall_Normal_ua.64c586fc.webp";